module.exports = __webpack_public_path__ + "img/cross.cb3edd9b.svg";